import { render, staticRenderFns } from "./AcessarPedidoDocumentosView.vue?vue&type=template&id=7a49b9db&scoped=true"
import script from "./AcessarPedidoDocumentosView.vue?vue&type=script&lang=js"
export * from "./AcessarPedidoDocumentosView.vue?vue&type=script&lang=js"
import style0 from "./AcessarPedidoDocumentosView.vue?vue&type=style&index=0&id=7a49b9db&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a49b9db",
  null
  
)

export default component.exports